module.exports = __webpack_public_path__ + "img/San Marino.d699d7b4.svg";